<template>
  <DataList
    :item-model.sync="itemModel"
    :type-object="$constants.DATA_LISTS.GEOTAG_LIST"
    :label="label"
    :is-update-on-start="isUpdateOnStart"
    :clearable="true"
    :chips="true"
    :small-chips="true"
    :deletable-chips="true"
    :dense="dense"
    :multiple="multiple"
    :return-object="returnObject"
    :with-option-any="withOptionAny"
    :with-option-none="withOptionNone"
  >
    <template v-slot:item="{ item }">
      <TitleDashDescription
        :title="item.name"
        :description="item.country_state"
      />
    </template>
  </DataList>
</template>

<script>
import TitleDashDescription from '../microcomponents/TitleDashDescription.vue';
import DataList from './DataList.vue';

export default {
  name: 'GeotagList',

  components: {
    TitleDashDescription,
    DataList,
  },

  props: {
    geotagModel: {
      type: [Number, Array, Object],
      default: () => null,
    },
    label: {
      type: String,
      default: 'geotag',
    },
    isUpdateOnStart: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    withOptionAny: {
      type: Boolean,
      default: false,
    },
    withOptionNone: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    itemModel: {
      get() {
        return this.geotagModel;
      },
      set(val) {
        this.$emit('update:geotagModel', val);
      },
    },
  },
};
</script>
